import { LocationScope, LocationVarKey } from "@swivl-mono/types";

import { DetailsV3WorksheetsData } from "../Worksheets/DetailsV3/DetailsV3.Worksheets.Data";
import { DetailsV3SearchEntry, SearchResultCategory } from "./GlobalSearch.Types";

// Walks the real page registry — no parallel list to keep in sync.
export const DETAILS_V3_SEARCH_ENTRIES: DetailsV3SearchEntry[] = DetailsV3WorksheetsData[LocationScope.ORG].flatMap((page) =>
  (page.searchLabels ?? []).map((label, index) => ({
    id: `details-v3:${page.to}:${index}`,
    category: SearchResultCategory.DETAILS_V3 as const,
    title: label.title,
    subpage: page.to,
    // Omit if it'd just repeat the title, e.g. "Hours".
    breadcrumb: label.title === page.label ? undefined : page.label,
    snippet: label.snippet,
    swivlStaffOnly: page.swivlStaffOnly,
    matchText: [label.title, label.snippet].filter(Boolean).join(" ").toLowerCase()
  }))
);

// Reverse lookup for value matches — which subpage a given var lives on.
export function findDetailsV3SubpageForVarKey(key: LocationVarKey): { to: string; label: string; swivlStaffOnly?: boolean } | undefined {
  const page = DetailsV3WorksheetsData[LocationScope.ORG].find((p) => p.keys?.includes(key));
  return page ? { to: page.to, label: page.label, swivlStaffOnly: page.swivlStaffOnly } : undefined;
}
